import * as React from 'react';
import styled from 'styled-components';

import { GetProperty } from '../../../../__types__/generated/GetProperty';
import { useInlineMap } from '../../../utils/hooks/useInlineMap';

import { BaseButton } from '../../../ui/Button';
import { defaultMapStyles } from '../../../../../client/__config__/defaultMapStyles';

export const TextSection: React.FC<{ data: GetProperty }> = ({ data }) => {
  const hasCustomDescription = (arr: any) => {
    return (
      arr.filter((item: any) =>
        item.heading.match(/Brukes på www.privatmegleren.no/gi)
      ).length > 0
    );
  };

  const getCustomDescription = (arr: any) => {
    let description = arr.filter((item: any) =>
      item.heading.match(/Brukes på www.privatmegleren.no/gi)
    )[0];

    if (description) {
      const replaceImage = (str: string, images: Array<any>) => {
        str = str.replace(
          /(@jpg[0-9]{0,3})/g,
          (matched: any, index: any, original: any) => {
            const i: string = matched.replace(/\D/g, '');
            const imageIndex = parseInt(i) - 1;

            if (typeof imageIndex === 'number') {
              if (images[imageIndex] && images[imageIndex]?.url) {
                const imageUrl = images[imageIndex]?.url;
                if (imageUrl) {
                  return `<div alt="bilde i fritekster" class="description-image"><img src="${imageUrl}" /><div>`;
                }
              }
              return '';
            } else {
              return '';
            }
          }
        );
        return str;
      };

      const replaceHashtags = (str: string) => {
        const headings = str.match(/(#(.*))/g) || [];
        headings.map((item: string) => {
          str = str.replace(item, (matched: any, index: any, original: any) => {
            if (matched.match(/###/)) {
              return `<h3>${matched.replace('###', '')}</h3>`;
            } else if (matched.match(/##/)) {
              return `<h2>${matched.replace('##', '')}</h2>`;
            } else if (matched.match(/#/)) {
              return `<h1>${matched.replace('#', '')}</h1>`;
            } else {
              return matched;
            }
          });
        });
        return str;
      };

      const replacePhone = (str: string) =>
        str.replace(/(\s[0-9]{8})/, '<a href="tel:$1">$1</a>');

      const replaceEmail = (str: string) =>
        str.replace(
          /([a-z|0-9]+@[a-z|0-9]+.[a-z]{0,})/,
          '<a href="mailto:$1">$1</a>'
        );

      const replaceLinks = (str: string) =>
        str.replace(
          /(@link=\[(.*)]\[(.*)])/g,
          '<div class="inline-button-wrapper"><a class="inline-button" href="$2">$3</a><div>'
        );

      const replaceVideo = (str: string) =>
        str.replace(
          /(@video([0-9]+))/,
          '<div class="vimeo-inline"><div class="vimeo-inline-height"></div><iframe src="https://player.vimeo.com/video/$2?autoplay=1" width="100%" height="100%" frameborder="0"></iframe></div>'
        );

      const replaceMap = (str: string, coordinates?: any) => {
        str = str.replace(/@kart1/, () => {
          let c = `${coordinates?.lat};${coordinates?.lon}`;
          return `<div id="inline-map" data-coordinates="${c}"></div>`;
        });
        return str;
      };

      const replacePlaceholders = (str: string) => {
        str = replaceEmail(str);
        str = replaceMap(str, data?.getProperty?.location?.coordinates);
        str = replaceVideo(str);
        str = replacePhone(str);
        str = replaceImage(str, data?.getProperty?.images?.list || []);
        str = replaceHashtags(str);
        str = replaceLinks(str);

        str = str.replace(/\r\n/g, '<br>');
        return str;
      };

      return (
        <div
          dangerouslySetInnerHTML={{
            __html: replacePlaceholders(description.text),
          }}
        />
      );
    } else {
      return null;
    }
  };

  if (hasCustomDescription(data?.getProperty?.freetext?.list?.extra)) {
    useInlineMap({ mapId: 'inline-map', mapStyles: defaultMapStyles });
  }

  return (
    <StyledTextSection>
      <h1 style={{ marginBottom: '40px' }}>Informasjon om prosjektet</h1>
      {hasCustomDescription(data?.getProperty?.freetext?.list?.extra)
        ? getCustomDescription(data?.getProperty?.freetext?.list?.extra)
        : data?.getProperty?.freetext?.list?.all &&
          data?.getProperty?.freetext?.list?.all?.map((item, index) => {
            return (
              <div key={`text_${index}`}>
                <h2>{item?.heading}</h2>
                {item?.html ? (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item.html
                        .replace(
                          /Omkostninger/,
                          '<br/><strong>Omkostninger</strong><br />'
                        )
                        .replace(/&lt;b&gt;/g, '<b>')
                        .replace(/&lt;\/b&gt;/g, '</b>')
                        .replace(/-{2,}/g, '<hr />')
                        //.replace(/(\))(?!\))/g, ')</span><br />')
                        .replace(/(\()(?!(valgfritt|forutsatt))/g, '<span>(')
                        .replace('NB', '<br />NB'),
                    }}
                  />
                ) : null}
              </div>
            );
          })}
    </StyledTextSection>
  );
};

export const StyledTextSection = styled.div`
  margin-top: 100px;
  padding: 0 20px;
  display: block;
  color: ${({ theme }) => theme?.bottom?.text};
  overflow: hidden;

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: ${({ theme }) => theme?.bottom?.heading};
    margin-bottom: 10px;
  }

  a {
    color: ${({ theme }) => theme.defaultLinkColor};
    text-decoration: none;
  }

  .inline-button-wrapper {
    display: inline-block;
    margin: 20px 0;

    .inline-button {
      ${BaseButton}
      line-height: 3rem;
      background: ${({ theme }: { theme: any }) =>
        theme?.buttons?.solid?.primary?.background};
      color: ${({ theme }: { theme: any }) =>
        theme?.buttons?.solid?.primary?.color};
    }
  }

  .description-image {
    margin-top: 10px;

    img {
      width: 100%;
    }
  }

  .vimeo-inline {
    position: relative;
    width: 100%;

    .vimeo-inline-height {
      padding-top: 60%;
      display: block;
    }

    iframe {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
    }
  }

  #inline-map {
    width: 100%;
    min-height: 300px;
    background: rgb(40, 40, 40);
  }
`;
